import { Component, OnInit,ViewChild,TemplateRef, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
// import { BsModalRef } from 'ngx-bootstrap';
import { CONFIGCONSTANTS } from '../../../../config/app-constants';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { DashboardService } from '../../../../_services/dashboard.service';
import { first } from 'rxjs/operators';
import { LoaderService } from '../../../../_services/loader.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-item-wise-margin',
  templateUrl: './item-wise-margin.component.html',
  styleUrls: ['./item-wise-margin.component.scss'],
  
})
export class ItemWiseMarginComponent implements OnInit {

  @ViewChild(DatatableComponent, { static: false }) datatable: DatatableComponent;
  // Get datatble configuration -- start
  loadingIndicator = false;
  getSuccessResult= false;
  reorderable = CONFIGCONSTANTS.datatableConfig.reorderable;
  scrollbarH = CONFIGCONSTANTS.datatableConfig.scrollbarH;
  serverSorting = CONFIGCONSTANTS.datatableConfig.serverSorting;
  serverPaging = false;
  piningRight = CONFIGCONSTANTS.datatableConfig.piningRight;
  headerHeight = CONFIGCONSTANTS.datatableConfig.headerHeight;
  footerHeight = CONFIGCONSTANTS.datatableConfig.footerHeight;
  rowHeight = CONFIGCONSTANTS.datatableConfig.rowHeight;
  limitList: any[] = CONFIGCONSTANTS.datatableConfig.limitList;
  ColumnMode = ColumnMode;
  totalReords = CONFIGCONSTANTS.datatableConfig.page.totalReords;
  pageNumber = CONFIGCONSTANTS.datatableConfig.page.pageNumber;
  // size = CONFIGCONSTANTS.datatableConfig.page.size;
  size = 10;
  dtMessages = CONFIGCONSTANTS.datatableConfig.dtMessages;
  // Get datatble configuration -- end
  momentDateTime24Format = CONFIGCONSTANTS.momentDateTime24Format || 'MM/DD/YYYY hh:mm:ss';
  momentDateFormat = CONFIGCONSTANTS.momentDateFormat || 'MM/DD/YYYY';
  readonly noColumnRecordText = CONFIGCONSTANTS["dataTableListing"]["columnRecordMissingText"];

  public itemWiseMarginData = [];
  public Pharmacy_ID:any;
  public supplier_uuid:any;
  public suplier_name:any;
  public filter:any;
  public supplierName:any;
  public pharmacyid:any;
  public type:string = '';
  sortParam = 'created_at';
  sortOrder = 'desc';
  tableTitle:string = 'Margin Analysis per Item';
  marginFilter:string = "month";
  suplier:any
  //Export Report
  excelIconURL:string = 'assets/img/excel-icon.png';
  csvIconURL:string = 'assets/img/csv-icon.png';
  reportIconSvgURL:string = 'assets/img/report-icon.svg';
  csvClicked = true;
  excelClicked = false;
  reportType:string = 'default';
  exportType:string = 'csv';
  req:any;
  tableType:string;
  fileName:any;

  constructor(
    public modalRef: BsModalRef,
    public modalRefExport: BsModalRef,
    private dashService: DashboardService,
    private modalService: BsModalService,
    private loader: LoaderService,
  ) { }

  ngOnInit() {
    this.getItemWiseMargin();
  }
    /** Get status class from configuration
  * @param status Active/Inactive/Penging
  */
    public getStatusClass(status) {
      if (status) {
        return CONFIGCONSTANTS.statusClass[status];
      } else {
        return 'badge-primary';
      }
    }
    /**
     * Sort datatable fields
     * @param event event was triggered, start sort sequence
     */
    public onSort(event) {
      this.sortParam = event.sorts[0].prop;
      this.sortOrder = event.sorts[0].dir;
      this.rerender(false);
    }
  
    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    public setPage(pageInfo) {
      this.pageNumber = pageInfo.offset;
     //  this.rerender(false);
    }
    /**
     * Show number of records in datatable
     * @param value show total entries value 10,25,50,100
     */
    public changeLimit(value) {
      this.size = value;
      this.rerender(true);
    }
    /**
     * API call and refresh datatable value
     * @param goFirstPage set first page when param value true
     */
    private rerender(goFirstPage): void {
      if (goFirstPage) {
        this.pageNumber = 0;
      }
   }

  
   openExportModal(template: TemplateRef<any>) {
    this.modalRefExport = this.modalService.show(template, { 
      class: 'modal-md modal-dialog-centered', 
      backdrop:false 
    });
    this.reportType = 'default';
    this.exportType = 'csv';
    this.csvClicked = true;
    this.excelClicked = false;
  }

   //update export types - csv or excel
   toggleClick(imageType: string) {
     if (imageType === 'csv') {
       this.csvClicked = true
       this.excelClicked = false;
       this.exportType = 'csv';
     } else if (imageType === 'excel') {
       this.excelClicked = true
       this.csvClicked = false;
       this.exportType = 'excel';
     }
   }
  
   

   downloadData() {
    this.req = {
      Pharmacy_ID: this.Pharmacy_ID,
      supplier_uuid:this.supplier_uuid,
      exporttype : this.exportType,
      // exportTable : 1,
      filter: this.filter,
      isexport:true,
    }
    this.loader.showLoader();
    let date = new Date();
    let fullDate = date.getDate()+ "-" + (date.getMonth()+1) + "-" + date.getFullYear();
    this.fileName = `Medify_Item-wise Margin_${this.pharmacyid}_${this.supplierName}`;
    
  
    this.dashService.getItemWiseMargin(this.req)
      .subscribe(data => {
        this.loader.hideLoader();  
      },
      error => {
        this.loader.hideLoader();
        if(this.req.exporttype == 'excel'){
          const blob = new Blob([error.text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url= window.URL.createObjectURL(blob);
          saveAs(url,`${this.fileName}.xls`);
        }else{
          const blob = new Blob([error.text], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);
          saveAs(url, `${this.fileName}.csv`);
        }
        this.declined();
      },
      () => console.log('OK'));
    }
    
    
    getItemWiseMargin(){
      let obj = {
        "Pharmacy_ID": this.Pharmacy_ID,
        "supplier_uuid": this.supplier_uuid,
        "filter": this.filter,
    }
      this.dashService.getItemWiseMargin(obj)
      .subscribe(res => {
        this.loader.hideLoader();
        this.itemWiseMarginData = res.data;
        this.supplierName = this.itemWiseMarginData[0].supplier_name;
        this.pharmacyid = this.itemWiseMarginData[0].pharmacy_id;
        // this.totalReords = this.itemWiseMarginData.length;
      },
      error => {}
      )
    }
  
   declined(): void {
     this.modalRefExport.hide();
   }
  
   decline(): void {
     this.modalRef.hide();
   }
}
